import styled from '@emotion/styled';
import AppStoreBadge from './badges/AppStoreBadge';
import PlayStoreBadge from './badges/PlayStoreBadge';
import Typography from './text/Typography';
import Rating from './Rating';
import { colors, spacing } from '../../utils/styleguide';
import { IStoresInfo } from '../../types/@types/generated/contentful';

const BadgeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StoreInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StarsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 310px;
`;

const RatingBlock = styled(Rating)`
  margin-right: ${spacing[3]}px;
`;

const StoreInfo = ({
  campaign,
  storesInfo,
  variant,
  className,
  creative,
}: {
  campaign?: string;
  storesInfo?: IStoresInfo;
  variant?: 'dark' | 'light';
  className?: string;
  creative: string;
}) => {
  if (!storesInfo?.fields.identifier) {
    return null;
  }

  return (
    <StoreInfoContainer className={className}>
      <BadgeContainer>
        <AppStoreBadge creative={creative} campaign={campaign} />
        <PlayStoreBadge creative={creative} campaign={campaign} />
      </BadgeContainer>
      {storesInfo?.fields && (
        <StarsContainer>
          {storesInfo?.fields.rating && <RatingBlock rating={storesInfo?.fields.rating} />}
          <Typography
            variant="smallTextBold"
            color={variant === 'dark' ? colors.white : colors.black}
          >
            {storesInfo?.fields.identifier}
          </Typography>
        </StarsContainer>
      )}
    </StoreInfoContainer>
  );
};

export default StoreInfo;
